module.exports = __webpack_public_path__ + "img/m_fxgzs.a15312f0.png";